import { motion } from "framer-motion";
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter, LinkedinIcon } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-gray-300 pt-14 pb-6 border-t border-slate-800 ">
      
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-12">

        {/* Brand */}
        <div>
          <h2 className="text-2xl font-bold text-white">YS SKY Travel & Tour</h2>
          <p className="mt-3 text-2xl text-gray-400 leading-relaxed">
         ጉዞዎን ያልተገደበ ያርጉ
          </p>

         <div className="flex items-center space-x-4 mt-5">

  {/* Facebook */}
  <motion.a
    whileHover={{ scale: 1.15 }}
    href="https://www.facebook.com/profile.php?id=61580404940006"
    target="_blank"
    className="p-2 rounded-full bg-[#1877F2] text-white shadow-md hover:shadow-lg transition"
  >
    <Facebook size={18} />
  </motion.a>

  {/* LinkedIn */}
  <motion.a
    whileHover={{ scale: 1.15 }}
    href="https://www.linkedin.com/company/ys-sky-travel-and-tour-agency-plc"
    target="_blank"
    className="p-2 rounded-full bg-[#0A66C2] text-white shadow-md hover:shadow-lg transition"
  >
    <LinkedinIcon size={18} />
  </motion.a>

  {/* Instagram */}
  <motion.a
    whileHover={{ scale: 1.15 }}
    href="https://www.instagram.com/ysskytourandtravelagencyplc?igsh=MTNpcmllYzZyN3ZucA=="
    target="_blank"
    className="p-2 rounded-full bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white shadow-md hover:shadow-lg transition"
  >
    <Instagram size={18} />
  </motion.a>

  {/* Telegram */}
  <motion.a
    whileHover={{ scale: 1.15 }}
    href="https://t.me/ysskytourandtravel"
    target="_blank"
    className="p-2 rounded-full bg-[#0088CC] text-white shadow-md hover:shadow-lg transition"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M9.999 15.2 9.9 19c.4 0 .6-.2.8-.4l2-1.9 4.1 3c.8.4 1.3.2 1.5-.7l2.7-12.6v-.1c.2-.9-.3-1.3-1.1-1L3.3 10.2c-.8.3-.8.8-.1 1l4.4 1.4 10.2-6.4c.5-.3.9-.1.5.2l-8.3 8.8z" />
    </svg>
  </motion.a>

</div>

        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Quick Links</h3>
          <ul className="space-y-3">
            {[
              ["Home", "/"],
              ["Tours", "/tours"],
              ["News", "/news"],
              ["Visa Services", "/services/visa"],
              ["Contact Us", "/contact"],
            ].map(([label, link]) => (
              <li key={link}>
                <Link
                  to={link}
                  className="hover:text-white transition hover:pl-1 inline-block"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Services</h3>
          <ul className="space-y-3">
            <li><Link to="/services/hotels" className="hover:text-white transition hover:pl-1 inline-block">Hotel Booking</Link></li>
            <li><Link to="/services/airplane-tickets" className="hover:text-white transition hover:pl-1 inline-block">Air Tickets</Link></li>
            <li><Link to="/tours" className="hover:text-white transition hover:pl-1 inline-block">Tour Packages</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Contact Info</h3>
          <ul className="space-y-4">
           <li className="flex items-center space-x-3">
  <a
    href="tel:+251938625555"
    className="flex items-center space-x-2  transition"
  >
    <Phone size={18} />
    <span>+251 938 625 555</span>
  </a>
</li>

<li className="flex items-center space-x-3">
  <a
    href="tel:+251938635555"
    className="flex items-center space-x-2  transition"
  >
    <Phone size={18} />
    <span>+251 938 635 555</span>
  </a>
</li>

           <li className="flex items-center space-x-3">
  <a
    href="mailto:info@ysskytravel.com"
    className="flex items-center space-x-2  transition"
  >
    <Mail size={18} />
    <span>info@ysskytravel.com</span>
  </a>
</li>

           <li className="flex items-center space-x-3">
  <a
    href="https://maps.app.goo.gl/ZwJDyvAaeSfbdn4S8" 
    target="_blank"
    rel="noopener noreferrer"
    className="flex items-center space-x-2  transition"
  >
    <MapPin size={35} />
    <span>Addis Ababa, Jomo 1, Hawdi Mall, 2nd Floor, Office 216</span>
  </a>
</li>

          </ul>
        </div>

      </div>

      {/* Bottom */}
      <div className="border-t border-slate-800 mt-12 pt-6 text-center text-gray-500 text-sm">
  © {new Date().getFullYear()} YS SKY TRAVEL & TOUR AGENCY P.L.C — All rights reserved.
  <br />
  Powered by{" "}
  <a
    href="mailto:fortinotech@gmail.com"
    className="text-primary hover:underline"
  >
    Fortino Tech
  </a>
</div>

    </footer>
  );
}
